export default __webpack_public_path__ + "static/media/USHJA.34547d37.png";